<header class="menu-principal" [class.menu-principal--open]="mobileOpen()" [class.menu-principal--hidden]="hidden()">
  <div class="menu-principal__inner">
    <nav class="menu-principal__nav menu-principal__nav--left" aria-label="Navegación principal">
      @for (item of leftNav; track item.label) {
        @if (item.external) {
          <a
            class="btn-header"
            [class.is-mobile-only]="item.mobileOnly"
            [href]="item.url"
            target="_blank"
            rel="noopener"
            (mouseenter)="onItemEnter(item)"
            (mouseleave)="onItemLeave()"
            (click)="closeMobile()"
          >{{ item.label }}</a>
        } @else {
          <a
            class="btn-header"
            [class.is-mobile-only]="item.mobileOnly"
            [routerLink]="item.url"
            routerLinkActive="is-active"
            [class.is-active]="megamenuOpen() === item.megamenu && item.megamenu"
            (mouseenter)="onItemEnter(item)"
            (mouseleave)="onItemLeave()"
            (click)="closeMobile()"
          >{{ item.label }}</a>
        }
      }
    </nav>

    <a class="menu-principal__logo" routerLink="/" aria-label="Inicio" (click)="closeMobile()">
      <img
        ngSrc="/logos/logo-menu.svg"
        width="164"
        height="51"
        alt="Mack"
        class="menu-principal__logo-img menu-principal__logo-img--default"
        priority
      />
      <img
        ngSrc="/logos/logo-mack-hover.svg"
        width="164"
        height="51"
        alt=""
        class="menu-principal__logo-img menu-principal__logo-img--hover"
        aria-hidden="true"
      />
    </a>

    <nav class="menu-principal__nav menu-principal__nav--right" aria-label="Navegación secundaria">
      @for (item of rightNav; track item.label) {
        <a
          class="btn-header"
          [routerLink]="item.url"
          routerLinkActive="is-active"
          (click)="closeMobile()"
        >{{ item.label }}</a>
      }
      <a class="btn-primary menu-principal__cta" [routerLink]="cta.url" (click)="closeMobile()">
        {{ cta.label }}
      </a>
    </nav>

    <button
      type="button"
      class="menu-principal__toggle"
      (mouseenter)="onItemLeave()"
      [class.menu-principal__toggle--open]="mobileOpen()"
      [attr.aria-expanded]="mobileOpen()"
      [attr.aria-label]="mobileOpen() ? 'Cerrar menú' : 'Abrir menú'"
      (click)="toggleMobile()"
    >
      <span class="menu-principal__toggle-bar"></span>
      <span class="menu-principal__toggle-bar"></span>
      <span class="menu-principal__toggle-bar"></span>
    </button>
  </div>

  <div
    class="menu-principal__megamenu"
    [class.is-open]="megamenuOpen() === 'camiones'"
    (mouseenter)="cancelClose()"
    (mouseleave)="scheduleClose()"
  >
    <app-megamenu-camiones (linkClick)="megamenuOpen.set(null)" />
  </div>

  <div
    class="menu-principal__megamenu"
    [class.is-open]="megamenuOpen() === 'soluciones'"
    (mouseenter)="cancelClose()"
    (mouseleave)="scheduleClose()"
  >
    <app-megamenu-soluciones (linkClick)="megamenuOpen.set(null)" />
  </div>

  <div
    class="menu-principal__overlay"
    [class.is-open]="mobileOpen()"
    (click)="closeMobile()"
    aria-hidden="true"
  ></div>
  <aside
    class="menu-principal__drawer"
    [class.is-open]="mobileOpen()"
    aria-label="Menú móvil"
  >
      <div class="menu-principal__panels"
        [class.menu-principal__panels--sub]="activePanel()"
        [class.menu-principal__panels--sub2]="activeSolucionesRail()"
      >

        <!-- Panel raíz -->
        <div class="menu-principal__panel">
          <ul class="menu-principal__list">
            @for (item of leftNav; track item.label) {
              <li class="menu-principal__item">
                @if (item.external) {
                  <a
                    class="menu-principal__link"
                    [href]="item.url"
                    target="_blank"
                    rel="noopener"
                    (click)="closeMobile()"
                  >{{ item.label }}</a>
                } @else if (item.children?.length || item.url === '/camiones' || item.url === '/industrias') {
                  <button
                    type="button"
                    class="menu-principal__item-btn"
                    (click)="openPanel(item)"
                  >
                    <span>{{ item.label }}</span>
                    <svg class="menu-principal__chevron" viewBox="0 0 6 12" width="6" height="12" aria-hidden="true">
                      <path d="M0.5 0.5L5.5 6L0.5 11.5" stroke="currentColor" stroke-width="1.5" fill="none" />
                    </svg>
                  </button>
                } @else {
                  <a
                    class="menu-principal__link"
                    [routerLink]="item.url"
                    routerLinkActive="is-active"
                    (click)="closeMobile()"
                  >{{ item.label }}</a>
                }
              </li>
            }
            <li class="menu-principal__divider" aria-hidden="true"></li>
            @for (item of rightNav; track item.label) {
              <li class="menu-principal__item">
                <a
                  class="menu-principal__link"
                  [routerLink]="item.url"
                  routerLinkActive="is-active"
                  (click)="closeMobile()"
                >{{ item.label }}</a>
              </li>
            }
          </ul>
          <div class="menu-principal__drawer-footer">
            <a class="btn-primary menu-principal__drawer-cta" [routerLink]="cta.url" (click)="closeMobile()">
              {{ cta.label }}
            </a>
          </div>
        </div>

        <!-- Panel 2: sub -->
        <div class="menu-principal__panel" [attr.aria-hidden]="!activePanel() || null" [attr.inert]="!activePanel() ? '' : null">
          <div class="menu-principal__panel-header">
            <button type="button" class="menu-principal__back" (click)="closePanel()" aria-label="Volver">
              <svg viewBox="0 0 6 12" width="6" height="12" aria-hidden="true">
                <path d="M5.5 0.5L0.5 6L5.5 11.5" stroke="currentColor" stroke-width="1.5" fill="none" />
              </svg>
            </button>
            <span class="menu-principal__panel-title">{{ activePanel()?.label }}</span>
          </div>

          @if (activePanel()?.url === '/camiones') {
            <ul class="menu-principal__sublist-panel">
              @for (truck of trucksMobile(); track truck.slug) {
                <li>
                  @if (truck.showDetail) {
                    <a
                      class="menu-principal__sublink"
                      [routerLink]="'/camiones/' + truck.slug"
                      routerLinkActive="is-active"
                      (click)="closeMobile()"
                      [innerHTML]="truck.title | regSup"
                    ></a>
                  } @else {
                    <a
                      class="menu-principal__sublink"
                      [href]="truck.whatsUrl"
                      target="_blank"
                      rel="noopener"
                      (click)="closeMobile()"
                      [innerHTML]="truck.title | regSup"
                    ></a>
                  }
                </li>
              }
              <li>
                <a
                  class="menu-principal__sublink"
                  routerLink="/camiones"
                  routerLinkActive="is-active"
                  (click)="closeMobile()"
                >Ver todos los camiones</a>
              </li>
            </ul>
          } @else if (activePanel()?.url === '/industrias') {
            <ul class="menu-principal__sublist-panel">
              @for (industry of industriesMobile(); track industry.slug) {
                <li>
                  <a
                    class="menu-principal__sublink"
                    [routerLink]="'/industrias/' + industry.slug"
                    routerLinkActive="is-active"
                    (click)="closeMobile()"
                  >{{ industry.title }}</a>
                </li>
              }
              <li>
                <a
                  class="menu-principal__sublink"
                  routerLink="/industrias"
                  routerLinkActive="is-active"
                  (click)="closeMobile()"
                >Ver todas nuestras industrias</a>
              </li>
            </ul>
          } @else if (activePanel()?.url === '/servicio' && activePanel()?.noNav) {
            <ul class="menu-principal__sublist-panel">
              @for (railItem of megamenuSoluciones?.rail() ?? []; track railItem.key) {
                <li>
                  <button
                    type="button"
                    class="menu-principal__item-btn"
                    (click)="openSolucionesRail(railItem)"
                  >
                    <span>{{ railItem.label }}</span>
                    <svg class="menu-principal__chevron" viewBox="0 0 6 12" width="6" height="12" aria-hidden="true">
                      <path d="M0.5 0.5L5.5 6L0.5 11.5" stroke="currentColor" stroke-width="1.5" fill="none" />
                    </svg>
                  </button>
                </li>
              }
            </ul>
          } @else {
            <ul class="menu-principal__sublist-panel">
              @for (child of activePanel()?.children; track child.url) {
                <li>
                  <a
                    class="menu-principal__sublink"
                    [routerLink]="child.url"
                    routerLinkActive="is-active"
                    (click)="closeMobile()"
                  >{{ child.label }}</a>
                </li>
              }
            </ul>
          }

          <div class="menu-principal__drawer-footer">
            <a class="btn-primary menu-principal__drawer-cta" [routerLink]="cta.url" (click)="closeMobile()">
              {{ cta.label }}
            </a>
          </div>
        </div>

        <!-- Panel 3: columnas de rail (Soluciones) -->
        <div
          class="menu-principal__panel"
          [attr.aria-hidden]="!activeSolucionesRail() || null"
          [attr.inert]="!activeSolucionesRail() ? '' : null"
        >
          <div class="menu-principal__panel-header">
            <button
              type="button"
              class="menu-principal__back"
              (click)="closeSolucionesRail()"
              aria-label="Volver"
            >
              <svg viewBox="0 0 6 12" width="6" height="12" aria-hidden="true">
                <path d="M5.5 0.5L0.5 6L5.5 11.5" stroke="currentColor" stroke-width="1.5" fill="none" />
              </svg>
            </button>
            <span class="menu-principal__panel-title">{{ activeSolucionesRail()?.label }}</span>
          </div>

          @if (activeSolucionesRail()) {
            <div class="menu-principal__service-list">
              @for (column of (megamenuSoluciones?.content() ?? {})[activeSolucionesRail()!.key] ?? []; track $index) {
                <div class="menu-principal__service-group">
                  @if (column.title) {
                    <span class="menu-principal__service-group-label">{{ column.title }}</span>
                  }
                  @for (link of column.items; track link.url) {
                    @if (link.external) {
                      <a
                        class="menu-principal__sublink"
                        [href]="link.url"
                        target="_blank"
                        rel="noopener"
                        (click)="closeMobile()"
                      >{{ link.label }}</a>
                    } @else {
                      <a
                        class="menu-principal__sublink"
                        [routerLink]="link.url"
                        routerLinkActive="is-active"
                        (click)="closeMobile()"
                      >{{ link.label }}</a>
                    }
                  }
                </div>
              }
            </div>
          }

          <div class="menu-principal__drawer-footer">
            <a class="btn-primary menu-principal__drawer-cta" [routerLink]="cta.url" (click)="closeMobile()">
              {{ cta.label }}
            </a>
          </div>
        </div>

      </div>
    </aside>
</header>
